import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import styled, { css } from 'styled-components';
import tokens from '@te-digi/styleguide-tokens';

const DURATION = parseInt(tokens.transition.medium);
const StyledDiv = styled.div.withConfig({
  componentId: "sg1510__sc-1m3vxcc-0"
})(["transition:height ", ";", ""], tokens.transition.medium, props => props.fade && css(["mask-image:linear-gradient( #000 calc(100% - 3rem),transparent calc(100% - 0.5rem) );"]));
const CollapsibleContent = _ref => {
  var _collapsibleContentRe;
  let {
    children,
    className,
    id,
    initialHeight = 0,
    isOpen,
    lazy,
    ...rest
  } = _ref;
  const collapsibleContentRef = useRef(null);
  const scrollHeight = useRef((_collapsibleContentRe = collapsibleContentRef.current) === null || _collapsibleContentRe === void 0 ? void 0 : _collapsibleContentRe.scrollHeight);
  const [height, setHeight] = useState({});
  const defaultStyle = {
    height: isOpen ? 'auto' : "".concat(initialHeight, "px"),
    overflow: isOpen ? 'visible' : 'hidden'
  };
  const getTransitionStyles = state => {
    const styles = {
      entering: {
        height: "".concat(scrollHeight.current, "px"),
        overflow: 'hidden',
        visibility: 'visible'
      },
      entered: {
        height: 'auto',
        overflow: 'visible',
        visibility: 'visible'
      },
      exiting: {
        height: "".concat(initialHeight, "px"),
        overflow: 'hidden',
        visibility: 'visible'
      },
      exited: {
        height: "".concat(initialHeight, "px"),
        overflow: 'hidden',
        visibility: initialHeight ? 'visible' : 'hidden'
      }
    };
    return styles[state];
  };
  return /*#__PURE__*/React__default.createElement(Transition, {
    in: isOpen,
    mountOnEnter: lazy,
    nodeRef: collapsibleContentRef,
    onEnter: () => {
      var _collapsibleContentRe2;
      scrollHeight.current = (_collapsibleContentRe2 = collapsibleContentRef.current) === null || _collapsibleContentRe2 === void 0 ? void 0 : _collapsibleContentRe2.scrollHeight;
    },
    onExit: () => {
      var _collapsibleContentRe3;
      setHeight({
        height: (_collapsibleContentRe3 = collapsibleContentRef.current) === null || _collapsibleContentRe3 === void 0 ? void 0 : _collapsibleContentRe3.scrollHeight
      });
    },
    onExiting: () => {
      setHeight({});
    },
    timeout: DURATION,
    unmountOnExit: lazy
  }, state => /*#__PURE__*/React__default.createElement(StyledDiv, _extends({
    className: className
  }, rest, {
    fade: initialHeight > 0 && !isOpen,
    id: id,
    ref: collapsibleContentRef,
    style: {
      ...defaultStyle,
      ...getTransitionStyles(state),
      ...height
    }
  }), children));
};
CollapsibleContent.displayName = 'CollapsibleContent';
CollapsibleContent.propTypes = {
  /**
   * Text content of the component.
   */
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  initialHeight: PropTypes.number,
  isOpen: PropTypes.bool,
  /**
   * Mount children when component is open, unmount when closed.
   */
  lazy: PropTypes.bool
};

export { CollapsibleContent };
